<template>
  <div>
    <div>
      <!--      <div class="flex align-items-center justify-content-lg-end search-box">-->
      <!--        <input class="form-control search-background borders" type="text" placeholder="Search for logs..." />-->
      <!--        <button type="button" class="btn input-group-btn search-background search-button borders">-->
      <!--          <i class="fa fa-search" />-->
      <!--        </button>-->
      <!--      </div>-->
      <div v-if="loading" class="lds-ellipsis">
        <div />
        <div />
        <div />
      </div>
      <div v-else class="log-wrap mb-3">
        <logs-group
          v-for="(log, index) in groupedLogs"
          :key="index"
          :log-group="log"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment';
import axios from 'axios';
import LogsGroup from './LogsGroup';

export default {
  components: {
    LogsGroup,
  },
  props: {
    carrier: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    carrierLogs: [],
    logs: [],
    loading: true,
    today: moment().format('YYYY-MM-D'),
  }),
  computed: {
    groupedLogs() {
      const logGroups = [];
      this.carrierLogs.forEach(log => {
        let hasLogGroup = false;
        logGroups.forEach((logGroup, i) => {
          if (logGroup.date === log.created_date) {
            hasLogGroup = true;
            logGroup.logs.push(log);
            logGroups[i] = logGroup;
          }
        });
        if (!hasLogGroup) {
          logGroups.push({
            date: log.created_date,
            logs: [log],
          });
        }
      });
      return logGroups;
    },
  },
  mounted() {
    this.getLogs();
  },
  methods: {
    getLogs() {
      axios.get(`/carriers/${this.carrier.id}/logs`).then(res => {
        this.carrierLogs = res.data.data;
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  border-radius: 2px;
  max-width: 40%;
  padding: 8px !important;
  max-height: 36px;
}

input::placeholder {
  opacity: 0.5;
  font-size: 15px;
  color: #4c5669;
}

.lds-ellipsis {
  display: flex;
  justify-content: center;
  height: 50px;
  padding-top: 50px;
}

.lds-ellipsis div {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 10px !important;
  background: white;
  animation: loader 0.6s infinite alternate;
}

.lds-ellipsis > div:nth-child(2) {
  animation-delay: 0.2s;
}

.lds-ellipsis > div:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes loader {
  to {
    opacity: 0.1;
    transform: translate(0, -20px);
    background: #e0e5ea;
  }
}

.log-wrap {
  overflow-x: auto !important;
  max-height: 85vh;
}

.borders {
  border-radius: 2px;
}

.search-box {
  padding-top: 26px;
  padding-bottom: 12px;
}

.search-background {
  background-color: white;
}

.search-button {
  padding: 9px !important;
  max-height: 36px;
}

.m-b {
  margin-bottom: 5px;
}

.blue-grey {
  color: #808d98;
}
</style>



// WEBPACK FOOTER //
// src/components/carriers/Logs.vue